import React from 'react'
import undefsafe from 'undefsafe'

const renderMatrixLicenseSelector = ({
  itemMatrix,
  selectedMatrixLicense,
  onMatrixLicenseChange
}) => {
  const hasExtendedLicense = itemMatrix && Object.keys(itemMatrix).length > 1
  if (hasExtendedLicense) {
    return (
      <div className='cart-modal__variant-selector__option'>
        <h4 className='fds-c-text-heading -size-s'>Select a License</h4>
        <select className='fds-c-form-select' defaultValue={selectedMatrixLicense} onChange={onMatrixLicenseChange}>
          {Object.keys(itemMatrix).map((matrix, index) => {
            return <option
              key={index}
              value={matrix}
            >
              {undefsafe(itemMatrix[matrix], 'license_label')}
            </option>
          })}
        </select>
      </div>
    )
  } else {
    return (
      <div>
        <h4 className='fds-c-text-heading -size-s'>License Available</h4>
        <p className='fds-c-text-body -size-m'>{undefsafe(itemMatrix[selectedMatrixLicense], 'license_label')}</p>
      </div>
    )
  }
}

const renderMatrixSupportSelector = ({
  itemMatrix,
  selectedMatrixLicense,
  selectedMatrixSupport,
  onMatrixSupportChange
}) => {
  return (
    <div className='cart-modal__variant-selector__option'>
      <h4 className='fds-c-text-heading -size-s'>Select support duration</h4>
      <select className='fds-c-form-select' defaultValue={selectedMatrixSupport} onChange={onMatrixSupportChange}>
        {Object.keys(itemMatrix[selectedMatrixLicense].support).map((supportName, index) => {
          return (
            <option key={index} value={supportName}>
              {itemMatrix[selectedMatrixLicense].support[supportName].label}
            </option>
          )
        })}
      </select>
    </div>
  )
}

export default ({
  itemMatrix,
  selectedMatrixLicense,
  selectedMatrixSupport,
  onMatrixLicenseChange,
  onMatrixSupportChange
}) => {
  const hasItemSupport = itemMatrix &&
    Object.keys(itemMatrix)
      .some((license) => {
        const { support } = itemMatrix[license]
        return Object.keys(support).some((supportName) => {
          return support[supportName] && supportName !== 'none'
        })
      })
  return (
    <div className='fds-c-modal__section fds-u-text-align-center fds-u-p3 cart-modal__variant-selector'>
      {renderMatrixLicenseSelector({
        itemMatrix,
        selectedMatrixLicense,
        onMatrixLicenseChange
      })}
      {hasItemSupport && renderMatrixSupportSelector({
        itemMatrix,
        selectedMatrixLicense,
        selectedMatrixSupport,
        onMatrixSupportChange
      })}
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/components/modals/cart/itemMatrixSelector.js